const ArticleIcon = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Makale</title>
      <path
        d="M22 4.67068V16.7407C22 17.7007 21.22 18.6007 20.26 18.7207L19.93 18.7607C17.75 19.0507 14.39 20.1607 12.47 21.2207C12.21 21.3707 11.78 21.3707 11.51 21.2207L11.47 21.2007C9.54997 20.1507 6.20003 19.0507 4.03003 18.7607L3.73999 18.7207C2.77999 18.6007 2 17.7007 2 16.7407V4.66067C2 3.47067 2.96997 2.57068 4.15997 2.67068C6.25997 2.84068 9.43997 3.9007 11.22 5.0107L11.47 5.16067C11.76 5.34067 12.24 5.34067 12.53 5.16067L12.7 5.05068C13.33 4.66068 14.13 4.27068 15 3.92068V8.00069L17 6.67068L19 8.00069V2.78072C19.27 2.73072 19.53 2.70069 19.77 2.68069H19.83C21.02 2.58069 22 3.47068 22 4.67068Z"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />{" "}
      <path
        d="M12 5.49023V20.4902"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />{" "}
      <path
        d="M19 2.78027V8.00024L17 6.67023L15 8.00024V3.92023C16.31 3.40023 17.77 2.98027 19 2.78027Z"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />{" "}
    </svg>
  );
};

export default ArticleIcon;
